import React, { useState } from 'react'
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaCommentDots } from 'react-icons/fa';
import './ContactUs.css'
import { addDoc, collection } from 'firebase/firestore';
import { db } from '../../firebase/Config';
import LoadingForAll from '../../Pages/LoadingForAll';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../store/UserContext';
function ContactUs() {

  const {currentUser}=useUser();


  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
 
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try{
      await addDoc(collection(db, 'contact'), {
        name,
        email,
        subject,
        message,
        userId:currentUser.uid,
      });
      navigate('/');
    }
    catch(error){
      setError(error.message);
    }
    finally{
      setIsLoading(false);
      
    }
  }

  
 
  
  return (
   <div className="contact-container">
      <h1 className="contact-title">Contact Fashion Loop</h1>
      <p className="contact-subtitle">We'd love to hear from you! Reach out to us for any questions or feedback.</p>
      
      <div className="contact-content">
        <div className="contact-info">
          <div className="info-card">
            <div className="info-icon">
              <FaMapMarkerAlt />
            </div>
            <h3>Our Location</h3>
            <p>123 Fashion Avenue<br />New York, NY 10001<br />United States</p>
          </div>
          
          <div className="info-card">
            <div className="info-icon">
              <FaPhoneAlt />
            </div>
            <h3>Phone Number</h3>
            <p>+1 (555) 123-4567</p>
            <p>Mon-Fri: 9am - 6pm EST</p>
          </div>
          
          <div className="info-card">
            <div className="info-icon">
              <FaEnvelope />
            </div>
            <h3>Email Address</h3>
            <p>support@fashionloop.com</p>
            <p>inquiries@fashionloop.com</p>
          </div>
          
          <div className="info-card">
            <div className="info-icon">
              <FaCommentDots />
            </div>
            <h3>Live Chat</h3>
            <p>Available 24/7</p>
            <button className="chat-btn">Start Chat</button>
          </div>
        </div>
        
        <div className="contact-form">
          <h2>Send Us a Message</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Your Name</label>
              <input type="text" id="name" placeholder="Enter your name" required value={name} onChange={(e) => setName(e.target.value)} />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input type="email" id="email" placeholder="Enter your email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            
            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input type="text" id="subject" placeholder="What's this about?" value={subject} onChange={(e) => setSubject(e.target.value)} />
            </div>
            
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" rows="5" placeholder="Your message here..." required value={message} onChange={(e) => setMessage(e.target.value)}></textarea>
            </div>
            {error && <div className="error-message">{error}</div>}
            {isLoading && <LoadingForAll title="Sending message..."/>}
            <button type="submit" className="submit-btn">Send Message</button>
          </form>
        </div>
      </div>
      
      <div className="contact-map">
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.215209132576!2d-73.9878449241649!3d40.74844097138946!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259a9b3117469%3A0xd134e199a405a163!2sEmpire%20State%20Building!5e0!3m2!1sen!2sus!4v1687891234567!5m2!1sen!2sus" 
          width="100%" 
          height="400" 
          style={{ border: 0 }} 
          allowFullScreen="" 
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade"
          title="Fashion Loop Location"
        ></iframe>
      </div>
    </div>
  )
}

export default ContactUs